import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { getApiUrl } from '../config';
import toast from 'react-hot-toast';

function Contact() {
  const [formData, setFormData] = useState({
    address: '',
    phone: '',
    email: '',
    map_embed: '',
    meta_title: '',
    meta_description: '',
    meta_keywords: ''
  });


  useEffect(() => {
    fetch(getApiUrl('/api/info/contact'), {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
    })
    .then(res => res.json())
    .then(data => {
      console.log('Contact data received:', data);
      if (data && data.id) {
        setFormData(prev => ({ ...prev, ...data }));
      }
    })
    .catch(error => {
      console.error('Error fetching contact info:', error);
      toast.error('خطا در دریافت اطلاعات تماس');
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const res = await fetch(getApiUrl('/api/info/contact'), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        toast.success('اطلاعات تماس با موفقیت ذخیره شد');
      } else {
        toast.error('خطا در ذخیره اطلاعات تماس');
      }
    } catch (error) {
      console.error('Error saving contact info:', error);
      toast.error('خطا در ذخیره اطلاعات تماس');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        اطلاعات تماس
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 600 }}>
        <TextField
          fullWidth
          label="آدرس"
          name="address"
          value={formData.address}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={3}
        />

        <TextField
          fullWidth
          label="شماره تلفن"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          margin="normal"
        />

        <TextField
          fullWidth
          label="ایمیل"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          margin="normal"
        />

        <TextField
          fullWidth
          label="کد Embed نقشه (Google Map Embed)"
          name="map_embed"
          value={formData.map_embed}
          onChange={handleChange}
          margin="normal"
          multiline
          minRows={3}
          placeholder="<iframe src=...></iframe>"
        />

        <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
          تنظیمات SEO
        </Typography>

        <TextField
          fullWidth
          label="عنوان SEO"
          name="meta_title"
          value={formData.meta_title}
          onChange={handleChange}
          margin="normal"
        />

        <TextField
          fullWidth
          label="توضیحات SEO"
          name="meta_description"
          value={formData.meta_description}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={3}
        />

        <TextField
          fullWidth
          label="کلمات کلیدی SEO"
          name="meta_keywords"
          value={formData.meta_keywords}
          onChange={handleChange}
          margin="normal"
        />

        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 3 }}
        >
          ذخیره اطلاعات
        </Button>
      </Box>
    </Box>
  );
}

export default Contact; 